import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose } from '../../layout/redux/layoutActions'
import { Button, Input, Modal } from '../../components'
import {
  cleanIntegracaoUsuarioPdca,
  obterIntegracaoUsuarioPdca,
  setIntegracaoUsuarioPdca,
  gravarIntegracaoUsuarioPdca
} from './redux/integracaoUsuarioPdcaActions'

export default () => {
  const dispatch = useDispatch()
  const { sistema, statusModal, usuario } = useSelector(state => state.layoutState)
  const { integracao, loading } = useSelector(state => state.integracaoUsuarioPdcaState)
  const nls = require(`./nls/${sistema?.idioma}.json`)

  useEffect(() => {
    if (statusModal === 'integracaoUsuarioPdca') {
      dispatch(obterIntegracaoUsuarioPdca(nls))
    }
  }, [statusModal])

  const handleCloseModal = () => {
    dispatch([
      modalClose(),
      cleanIntegracaoUsuarioPdca()
    ])
  }

  const handleChange = e => {
    dispatch(setIntegracaoUsuarioPdca(e))
  }

  const handleConfirmar = () => {
    dispatch(gravarIntegracaoUsuarioPdca(integracao, nls, () => {
      dispatch([
        modalClose(),
        cleanIntegracaoUsuarioPdca()
      ])
    }))
  }

  return (
    <Modal
      title={nls.title}
      size='medium'
      open={statusModal === 'integracaoUsuarioPdca'}
      close={() => handleCloseModal()}
      closeText={nls.btnCancelar}
      actions={
        <>
          <Button
            color='default'
            onClick={() => handleCloseModal()}
          >
            {nls.btnCancelar}
          </Button>

          <Button
            color='primary'
            onClick={() => handleConfirmar()}
            disabled={loading}
          >
            {nls.btnConfirmar}
          </Button>
        </>
      }
    >
      <div>
        <div className='form-grid form-grid-2'>
          <Input
            name='asanaemail'
            label={nls.asanaEmail}
            value={usuario?.email || ''}
            disabled={true}
          />

          <Input
            name='clickupemail'
            label={nls.clickupEmail}
            value={usuario?.email || ''}
            disabled={true}
          />
        </div>

        <div className='form-grid form-grid-2'>
          <Input
            name='mondayemail'
            label={nls.mondayEmail}
            value={usuario?.email || ''}
            disabled={true}
          />

          <Input
            name='usernametrello'
            label={nls.trelloUsername}
            value={integracao?.usernametrello || ''}
            action={(e) => handleChange(e)}
            maxLength={50}
          />
        </div>

        <div className='form-grid'>
          <Input
            name='useraccountidjira'
            label={nls.jiraUserAccountId}
            value={integracao?.useraccountidjira || ''}
            action={(e) => handleChange(e)}
            maxLength={50}
          />
        </div>
      </div>
    </Modal>
  )
}